import {
  VERIFY_OTP_LAMF_SUCCESS,
  GET_CLIENT_DATA_LAMF_SUCCESS,
} from "../types";

const initialState = {
  referralLink: "",
  headerToken: "",
  clientList: [],
  earnings: "",
  totalLoanAmount: "",
};

export function lamfReducer(state = initialState, action) {
  switch (action.type) {
    case VERIFY_OTP_LAMF_SUCCESS: {
      const { referralLink, token } = action.body;
      return {
        ...state,
        headerToken: token,
        referralLink,
      };
    }
    case GET_CLIENT_DATA_LAMF_SUCCESS: {
      const { referralData, data } = action.body;
      if (!referralData.length) {
        return {
          ...state,
          clientList: [],
        };
      } else {
        return {
          ...state,
          clientList: referralData,
          earnings: data.earnings,
          totalLoanAmount: referralData.reduce(
            (acc, curr) => acc + +curr.creditLineAmount
          ),
        };
      }
    }

    default:
      return state;
  }
}
